import { tronAddressToEthAddress } from '../../../../../../../utils/tronAddressToEthAddress';

export const createSignMultiCallMessage = ({
  rowData,
  rawTx,
  isTron,
}: {
  rowData: any;
  rawTx: any;
  isTron: boolean;
}) => {
  // const chainType = rowData?.chain_type;
  // const isTron = Number(chainType) === 3;

  const fromAddress = rawTx?.from;
  const toAddress = rawTx?.to;
  const value = rawTx?.value;
  const data = rawTx?.data;
  const nonce = rawTx?.nonce;
  const batchId = rawTx?.batch_id;

  const processedFromAddress = isTron ? tronAddressToEthAddress(fromAddress || '') : fromAddress;

  const createMultiCallTxs = () => {
    return rawTx?.to?.map((item: any, index: string | number) => {
      const toAddress = rawTx?.to?.[index];
      const value = rawTx?.value?.[index];
      const byteData = rawTx?.data?.[index] ? rawTx?.data?.[index] : '0x';

      return {
        to: isTron ? tronAddressToEthAddress(toAddress || '') : toAddress,
        value: value,
        data: isTron ? `0x${rawTx?.data?.[index]}` : byteData,
      };
    });
  };

  const payload = {
    from: processedFromAddress,
    // multicallTxs: [
    //   {
    //     to: '0x3Dd9571158D0F2Ca8cB74F47f4C17d81FdbC7bad',
    //     value: '0',
    //     data: '0xa9059cbb000000000000000000000000866074e47306d55b9571a84e2dca44e075e757fe0000000000000000000000000000000000000000000000000000000005f5e100',
    //   },
    //   {
    //     to: '0x3Dd9571158D0F2Ca8cB74F47f4C17d81FdbC7bad',
    //     value: '0',
    //     data: '0xa9059cbb000000000000000000000000f29cf83c727a53d764c1221fb3ff4343df74edba00000000000000000000000000000000000000000000000000000000055d4a80',
    //   },
    // ],
    multicallTxs: createMultiCallTxs(),
    nonce: nonce,
    batchId: batchId,
    requireSuccess: true,
  };

  return payload;
};
